export default "__VITE_ASSET__CM7Q2tol__"